module.exports = __webpack_public_path__ + "img/002-adventure.4b664699.svg";